document.addEventListener('DOMContentLoaded', function() {
    
    // --- TAB CLICKING LOGIC ---
    var tabBtns = document.querySelectorAll('.sg-tab-btn');
    
    function activateTab(btn) {
        var targetId = btn.getAttribute('data-target');
        var imgUrl = btn.getAttribute('data-img');
        
        // Hide all tables & remove active class from all buttons
        document.querySelectorAll(".sg-table").forEach(t => t.classList.remove("active"));
        tabBtns.forEach(t => t.classList.remove("active"));
        
        // Show target table and animate
        var activeTable = document.getElementById("table-" + targetId);
        if(activeTable) {
            activeTable.classList.add("active");
            activeTable.classList.remove("sg-animate-content");
            void activeTable.offsetWidth; // Trigger reflow for animation
            activeTable.classList.add("sg-animate-content");
        }

        // Set button to active
        btn.classList.add("active");
        
        // Swap Image
        var sgImg = document.getElementById("sg-dynamic-img");
        if(sgImg && imgUrl) {
            sgImg.src = imgUrl;
            sgImg.classList.remove("sg-animate-content");
            void sgImg.offsetWidth; 
            sgImg.classList.add("sg-animate-content");
        }
    }

    // Attach click listeners safely
    tabBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            activateTab(this);
        });
    });

    // --- SWIPE GESTURES FOR MOBILE TABS ---
    var touchstartX = 0;
    var touchendX = 0;
    var sgContentWrapper = document.querySelector('.sg-content-wrapper');

    if (sgContentWrapper) {
        sgContentWrapper.addEventListener('touchstart', function(e) { 
            touchstartX = e.changedTouches[0].screenX; 
        }, {passive: true});

        sgContentWrapper.addEventListener('touchend', function(e) { 
            touchendX = e.changedTouches[0].screenX; 
            var threshold = 50; 
            if(tabBtns.length < 2) return; 

            // Swipe Left -> Switch to Regular
            if (touchendX < touchstartX - threshold && tabBtns[1].classList.contains('active')) {
                tabBtns[0].click(); 
            }
            // Swipe Right -> Switch to Oversized
            if (touchendX > touchstartX + threshold && tabBtns[0].classList.contains('active')) {
                tabBtns[1].click(); 
            }
        }, {passive: true});
    }
});

// Removed all IntersectionObserver animation code

function epToggleFAQ(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // 1. Close all accordions first
    const allButtons = document.querySelectorAll('.ep-faq-btn');
    allButtons.forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        // Reset icon to plus
        btn.querySelector('.ep-faq-icon').innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>';
    });

    // 2. If the clicked accordion wasn't already open, open it
    if (!isExpanded) {
        button.setAttribute('aria-expanded', 'true');
        // Change icon to minus
        button.querySelector('.ep-faq-icon').innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"></path>';
    }
}